import styled from "styled-components"


export const NameWrapper = styled.div`
display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  svg {
    height: 1.4rem;
  }

  &:hover {
    cursor: pointer;
  }
`

export const ExpandAnimation = styled.div`
  opacity: 0;
  transform: translateY(-10px);
  animation: fadeInExpand 0.5s ease forwards;

  @keyframes fadeInExpand {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

